import { TThunkAction } from '../../../shared/types/redux/thunk';
import {
  fetchGetNewbuildingLayoutsDesktopFichering,
  IGetNewbuildingLayoutsDesktopFicheringResponse200,
  IGetNewbuildingLayoutsDesktopFicheringResponse400,
} from '../../repositories/newbuilding-card/v1/get-newbuilding-layouts-desktop-fichering';
import { getCurrentHouse, getCurrentRoomsCount } from '../../selectors/layouts';
import { getLayoutsHouses } from '../../selectors/newbuilding';
import { ERoomsCount } from '../../types/newbuilding/layouts';
import { getAvailableRoomsCount, getHouseInfo } from '../../utils/layouts';
import { setLayoutsData } from './actions';

export function changeHouseId(houseId: number): TThunkAction {
  return async (dispatch, getState, { httpApi, logger }): Promise<void> => {
    try {
      const state = getState();
      let roomsCount = getCurrentRoomsCount(state);

      const houses = getLayoutsHouses(state);
      const house = getHouseInfo(houseId, houses);
      const rooms = house?.roomsCountList || [];
      roomsCount = getAvailableRoomsCount(roomsCount, rooms);

      if (houseId !== getCurrentHouse(state) || roomsCount !== getCurrentRoomsCount(state) || !state.layouts?.data) {
        const parameters = {
          houseId,
          roomsCount,
          newbuildingId: state.newbuilding.id,
        };
        const response = await fetchGetNewbuildingLayoutsDesktopFichering<
          IGetNewbuildingLayoutsDesktopFicheringResponse200,
          IGetNewbuildingLayoutsDesktopFicheringResponse400
        >({
          httpApi,
          parameters,
        });

        if (response.statusCode === 400) {
          throw response.response.message;
        }

        const payload = {
          houseId,
          roomsCount,
          data: response.response.layouts || null,
        };
        dispatch(setLayoutsData(payload));
      }
    } catch (error) {
      logger.error(error, {
        houseId,
        domain: 'changeHouseId',
      });
    }
  };
}

export function changeRoomsCount(roomsCount: ERoomsCount | undefined): TThunkAction {
  return async (dispatch, getState, { httpApi, logger }): Promise<void> => {
    try {
      const state = getState();
      const houseId = getCurrentHouse(state);

      if (houseId !== getCurrentHouse(state) || roomsCount !== getCurrentRoomsCount(state) || !state.layouts?.data) {
        const parameters = {
          houseId,
          roomsCount,
          newbuildingId: state.newbuilding.id,
        };
        const response = await fetchGetNewbuildingLayoutsDesktopFichering<
          IGetNewbuildingLayoutsDesktopFicheringResponse200,
          IGetNewbuildingLayoutsDesktopFicheringResponse400
        >({
          httpApi,
          parameters,
        });

        if (response.statusCode === 400) {
          throw response.response.message;
        }

        const payload = {
          houseId,
          roomsCount,
          data: response.response.layouts || null,
        };
        dispatch(setLayoutsData(payload));
      }
    } catch (error) {
      logger.error(error, {
        roomsCount,
        domain: 'changeRoomsCount',
      });
    }
  };
}
